import { render, staticRenderFns } from "./LeadForm.vue?vue&type=template&id=7ca6707f&lang=pug&"
import script from "./LeadForm.vue?vue&type=script&lang=js&"
export * from "./LeadForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports